import type { TileImage, Variation } from '@shared/types/types.ts';
import type { ProductLink } from '@tile/components/product-title/ProductLink';
import type { ProductTitle } from '@tile/components/product-title/ProductTitle.ts';
import { getLayoutImages } from '@tilelist/layouts/mapping/LayoutImages.ts';
import { mapLink } from '@tilelist/layouts/mapping/ProductLink.ts';
import { mapShortTitle } from '@tilelist/layouts/mapping/ProductTitle.ts';

/**
 *
 *
 *
 *
 */
export type DefaultLayout = {
    /**
 *
 */
    readonly variation: Variation;

    /**
 *
 */
    readonly title: ProductTitle;

    readonly link: ProductLink;

    readonly images: TileImage[];

    readonly primaryImage: TileImage;

    readonly showMultipleSizes: boolean;
};

/**
 *
 */
export function createDefaultLayout(
    variation: Variation,
    showTopInfos: boolean,
    showMultipleSizes: boolean,
): DefaultLayout {
    const patchedVariation: Variation = {
        ...variation,
        topInfos: showTopInfos && variation.topInfos?.length ? variation.topInfos : undefined,
    };
    const { images, primaryImage } = getLayoutImages(variation);
    return {
        variation: patchedVariation,
        title: mapShortTitle(variation),
        link: mapLink(variation),
        images,
        primaryImage,
        showMultipleSizes,
    };
}
